import * as React from 'react';
import { withInjectedRootStore, RootStore } from '../../providers';

export interface LoggedInProps {
  rootStore: RootStore;
  children(isLoggedIn: boolean): React.ReactNode;
}

export const useUserLoggedIn = (rootStore: RootStore) => {
  return { isLoggedIn: !rootStore.appStore.isAnonymous };
};

class LoggedInComp extends React.Component<LoggedInProps> {
  render() {
    const { children, rootStore } = this.props;
    return children(!rootStore.appStore.isAnonymous);
  }
}

export const LoggedIn = withInjectedRootStore(LoggedInComp);
